import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "menu_device_model2",
  "use": "menu_device_model2-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"menu_device_model2\">\r\n    <path d=\"M10.0002 0.833252L17.9168 5.41658V14.5833L10.0002 19.1666L2.0835 14.5833V5.41658L10.0002 0.833252ZM4.5784 5.898L10.0002 9.03692L15.422 5.89804L10.0002 2.75909L4.5784 5.898ZM3.75016 7.34433V13.6223L9.16691 16.7583V10.4803L3.75016 7.34433ZM10.8336 16.7583L16.2502 13.6223V7.34439L10.8336 10.4803V16.7583Z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol